const temperamentosTraducidos = {
  "Active": "Activo",
  "Adaptable": "Adaptable",
  "Adventurous": "Aventurero",
  "Affectionate": "Cariñoso",
  "Aggressive": "Agresivo",
  "Agile": "Ágil",
  "Alert": "Alerta",
  "Aloof": "Reservado",
  "Amiable": "Amable",
  "Assertive": "Asertivo",
  "Athletic": "Atlético",
  "Attentive": "Atento",
  "Benevolent": "Benévolo",
  "Bold": "Audaz",
  "Boisterous": "Ruidoso",
  "Bossy": "Mandón",
  "Brave": "Valiente",
  "Bright": "Brillante",
  "Bubbly": "Efervescente",
  "Calm": "Calmado",
  "Cat-like": "Gato",
  "Cautious": "Cauto",
  "Cheerful": "Alegre",
  "Clever": "Astuto",
  "Clownish": "Payaso",
  "Companionable": "Compasivo",
  "Composed": "Sereno",
  "Confident": "Seguro de sí mismo",
  "Cooperative": "Cooperativo",
  "Courageous": "Corajudo",
  "Cunning": "Astuto",
  "Curious": "Curioso",
  "Determined": "Determinado",
  "Devoted": "Dedicado",
  "Dignified": "Digno",
  "Diligent": "Diligente",
  "Docile": "Dócil",
  "Dominant": "Dominante",
  "Dutiful": "Obediente",
  "Eager": "Ansioso",
  "Easygoing": "De trato fácil",
  "Energetic": "Energético",
  "Even Tempered": "De temperamento equilibrado",
  "Excitable": "Excitable",
  "Extroverted": "Extrovertido",
  "Faithful": "Fiel",
  "Familial": "Familiar",
  "Fast": "Rápido",
  "Fearless": "Intrépido",
  "Feisty": "Peleón",
  "Fierce": "Feroz",
  "Friendly": "Amistoso",
  "Fun-loving": "Amante de la diversión",
  "Gay": "Alegre",
  "Generous": "Generoso",
  "Gentle": "Gentil",
  "Good-natured": "De buen carácter",
  "Good-tempered": "De buen temperamento",
  "Great-hearted": "De gran corazón",
  "Happy": "Feliz",
  "Hardworking": "Trabajador",
  "Hardy": "Robusto",
  "Independent": "Independiente",
  "Inquisitive": "Curioso",
  "Intelligent": "Inteligente",
  "Joyful": "Alegre",
  "Keen": "Perspicaz",
  "Kind": "Amable",
  "Lively": "Animado",
  "Lovable": "Adorable",
  "Loving": "Amoroso",
  "Loyal": "Leal",
  "Merry": "Alegre",
  "Mischievous": "Travieso",
  "Obedient": "Obediente",
  "Opinionated": "Terco",
  "Outgoing": "Extrovertido",
  "Patient": "Paciente",
  "People-Oriented": "Orientado hacia las personas",
  "Playful": "Juguetón",
  "Powerful": "Poderoso",
  "Protective": "Protector",
  "Proud": "Orgulloso",
  "Quick": "Rápido",
  "Quiet": "Callado",
  "Rational": "Racional",
  "Receptive": "Receptivo",
  "Refined": "Refinado",
  "Reliable": "Confiable",
  "Reserved": "Reservado",
  "Respectful": "Respetuoso",
  "Responsible": "Responsable",
  "Responsive": "Sensible",
  "Rugged": "Robusto",
  "Self-assured": "Seguro de sí mismo",
  "Self-confidence": "Confianza en sí mismo",
  "Self-important": "Egocéntrico",
  "Sensitive": "Sensible",
  "Sociable": "Sociable",
  "Spirited": "Animado",
  "Spunky": "Entusiasta",
  "Stable": "Estable",
  "Steady": "Constante",
  "Strong": "Fuerte",
  "Strong Willed": "De voluntad fuerte",
  "Stubborn": "Terco",
  "Sturdy": "Resistente",
  "Suspicious": "Desconfiado",
  "Sweet-Tempered": "De temperamento dulce",
  "Tenacious": "Tenaz",
  "Territorial": "Territorial",
  "Thoughtful": "Considerado",
  "Tolerant": "Tolerante",
  "Trainable": "Adaptable",
  "Trusting": "Confiable",
  "Trustworthy": "Digno de confianza",
  "Unflappable": "Imperturbable",
  "Vigilant": "Vigilante",
  "Vocal": "Vocal",
  "Watchful": "Atento",
  "Wild": "Salvaje",
  "Willful": "Voluntarioso"
  };
  
  export default temperamentosTraducidos;
  